var _g, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScrollleft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2341_3534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 53C45.3891 53 53 45.3891 53 36C53 26.6109 45.3891 19 36 19C26.6109 19 19 26.6109 19 36C19 45.3891 26.6109 53 36 53Z",
    fill: "#084BB0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.155 49.5366C43.5446 49.5366 49.5347 43.5465 49.5347 36.157C49.5347 28.7674 43.5446 22.7773 36.155 22.7773C28.7655 22.7773 22.7754 28.7674 22.7754 36.157C22.7754 43.5465 28.7655 49.5366 36.155 49.5366Z",
    fill: "white",
    stroke: "#82BFD2",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1484 42.1784L40.1693 36.1576L34.1484 30.1367",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1484 42.1784L40.1693 36.1576L34.1484 30.1367",
    stroke: "#084BB0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2341_3534",
    x: 0.200001,
    y: 0.200001,
    width: 71.6,
    height: 71.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.4,
    result: "effect1_foregroundBlur_2341_3534"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollleft);
export default __webpack_public_path__ + "static/media/Scroll left.60f344a95ad73071ff078d942df731f5.svg";
export { ForwardRef as ReactComponent };